export default "__VITE_ASSET__CcZRBSNA__"